// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAmWoGkuGSgx1SfqXkJ3JZ-dtOVYUg51TE',
    authDomain: 'befirst-qa.firebaseapp.com',
    databaseURL: 'https://befirst-qa.firebaseio.com',
    projectId: 'befirst-qa',
    storageBucket: 'befirst-qa.appspot.com',
    messagingSenderId: '1074134709684'
  }
};
